import { Container as ChakraContainer } from '@chakra-ui/layout';

export const Container = ChakraContainer;
